import { StoryblokImageWithOptionalText } from './StoryblokImageWithOptionalText'

import { createImageWithOptionalText } from './__mocks__/imageWithOptionalText'

export { createImageWithOptionalText }

// Re-export for backward compatibility
export const dummyImageWithOptionalTextStoryblok = createImageWithOptionalText()

export default StoryblokImageWithOptionalText
